/**
 * Registry-driven drawing keyboard actions. One source of truth mapping a
 * `DrawingKind` to how it's removed, so the chart's Delete handler is a single
 * lookup instead of a hand-maintained per-kind switch.
 *
 * `Record<DrawingKind, …>` is exhaustive: adding a new drawing kind to the
 * union makes this map a COMPILE error until you wire its remover — the same
 * "can't silently forget a tool" guarantee as the persistence layer.
 */
import {
  removeFib,
  removeHorizontalLine,
  removeVerticalLine,
  removeDiagonalLine,
  removePath,
  removePosition,
  removePriceRangeBox,
  removeTextLabel,
  type DrawingKind,
} from "@/state/slices/uiSlice";
import type { AppDispatch } from "@/state/store";

type Remover = (dispatch: AppDispatch, tabId: string, id: string) => void;

export const DRAWING_REMOVERS: Record<DrawingKind, Remover> = {
  fib: (d, tabId, id) => d(removeFib({ tabId, id })),
  hline: (d, tabId, id) => d(removeHorizontalLine({ tabId, id })),
  vline: (d, tabId, id) => d(removeVerticalLine({ tabId, id })),
  diagonal: (d, tabId, id) => d(removeDiagonalLine({ tabId, id })),
  path: (d, tabId, id) => d(removePath({ tabId, id })),
  position: (d, tabId, id) => d(removePosition({ tabId, id })),
  priceRange: (d, tabId, id) => d(removePriceRangeBox({ tabId, id })),
  text: (d, tabId, id) => d(removeTextLabel({ tabId, id })),
};
